// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Inter:400,500,700&display=swap']
    },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
// require('magnific-popup/dist/jquery.magnific-popup.min');
// require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
// require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/menu');
// require('./modules/accordion');
// require('./modules/animatein');
// require('./modules/bannerVideo');
require('./modules/formInputs');
// require('./modules/localVideoBlock');
// require('./modules/modal');
// require('./modules/scrollTo');
// require('./modules/searchToggle');
// require('./modules/shareSocial');
// require('./modules/sideMenu');
// require('./modules/tabs');
// require('./modules/alert');
